import React from "react";
import DialogTitle from "@material-ui/core/DialogTitle";
import Dialog from "src/components/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import { format } from "date-fns";

import type { SupportUserEvent } from "src/interfaces/userEvents.interface";

const useStyles = makeStyles((theme) => ({
  field: {
    marginTop: theme.spacing(1),
    wordBreak: "break-word",
  },
  mono: {
    fontFamily: "monospace",
    fontSize: "0.85rem",
    whiteSpace: "pre-wrap",
    wordBreak: "break-word",
    marginTop: theme.spacing(1),
  },
}));

interface EventDetailsDialogProps {
  event: SupportUserEvent | null;
  open: boolean;
  onClose: () => void;
  onExited?: () => void;
}

function EventDetailsDialog({
  event,
  open,
  onClose,
  onExited,
}: EventDetailsDialogProps) {
  const classes = useStyles();
  const payloadJson = event?.payload
    ? JSON.stringify(event.payload, null, 2)
    : event
    ? JSON.stringify(event, null, 2)
    : "";

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      TransitionProps={{ onExited }}
    >
      <DialogTitle>Event details</DialogTitle>
      <DialogContent>
        {event ? (
          <>
            <Typography variant="body2" className={classes.field}>
              <strong>ID:</strong> {event.id}
            </Typography>
            <Typography variant="body2" className={classes.field}>
              <strong>Date:</strong>{" "}
              {event.date
                ? format(new Date(event.date), "MMM d, yyyy h:mm a")
                : "—"}
            </Typography>
            <Typography variant="body2" className={classes.field}>
              <strong>Type:</strong> {event.type || "—"}
            </Typography>
            {event.feature ? (
              <Typography variant="body2" className={classes.field}>
                <strong>Feature:</strong> {event.feature}
              </Typography>
            ) : null}
            {event.element ? (
              <Typography variant="body2" className={classes.field}>
                <strong>Element:</strong> {event.element}
              </Typography>
            ) : null}
            {event.message ? (
              <Typography variant="body2" className={classes.field}>
                <strong>Message:</strong> {event.message}
              </Typography>
            ) : null}
            {event.source ? (
              <Typography variant="body2" className={classes.field}>
                <strong>Source:</strong> {event.source}
              </Typography>
            ) : null}
            {event.clientVersion ? (
              <Typography variant="body2" className={classes.field}>
                <strong>Client version:</strong> {event.clientVersion}
              </Typography>
            ) : null}
            <Typography variant="body2" className={classes.field}>
              <strong>Full event:</strong>
            </Typography>
            <Typography
              component="pre"
              variant="body2"
              className={classes.mono}
            >
              {payloadJson}
            </Typography>
          </>
        ) : null}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default EventDetailsDialog;
